export default __webpack_public_path__ + "static/toggl-track-pricing-plans-7f9901961e07b5cd75c0f10996f51252.jpg";